<template>
  <section class="page-wrapper">
    <div  v-if="$wait.any" class="loading-wrapper">
      <LoadingBounce />
    </div>
    <section class="video-lecture-wrapper" v-else>
      <header class="header-wrapper">
        <div class="subject-name">
          {{ subjectName }}
        </div>
      </header>
      <PreviewVideo :url="videoLectureUrl" />
      <section class="content-wrapper">
        <div class="video-title">
          {{ videoLectureTitle }}
        </div>
        <div class="video-description">
          {{ videoLectureDescription }}
        </div>
        <div class="owner-name">
          {{ ownerName }}
          &middot;
          {{ $t('common.view_count', { view_count: videoLectureViewCount }) }}
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'preview-video-page',

  computed: {
    ...mapGetters({
      routeParams: 'getRouteParams',
      viideoLecture: 'getVideoLecture',
      isLoading: 'isLoading',
      isTeacherUser: 'isTeacherUser',
    }),

    videoLectureTitle() {
      return this.viideoLecture.title || '';
    },

    videoLectureSubject() {
      return this.viideoLecture.subject || {};
    },

    subjectName() {
      return this.videoLectureSubject.name || '-';
    },

    videoLectureUrl() {
      return this.viideoLecture.video.embed || '';
    },

    videoLectureDescription() {
      return this.viideoLecture.description || '';
    },

    owner() {
      return this.viideoLecture.owner || {};
    },

    ownerName() {
      return this.owner.name || '-';
    },

    videoLectureViewCount() {
      return this.viideoLecture.view_count || 0;
    },

  },

  methods: {
    ...mapActions([
      'fetchVideoLecture',
    ]),
  },

  beforeMount() {
    if (!this.isTeacherUser) {
      this.$router.push('/404');
      return;
    }

    this.$wait.start();
    this.fetchVideoLecture(this.routeParams.id);
    this.$wait.end();
  },
};
</script>

<style lang="scss" scoped>
  .loading-wrapper {
    margin-top: 180px;
    height: 100%;
  }

  .page-wrapper {
    user-select: none;
    height: 100%;
  }

  .video-lecture-wrapper {
    padding: 16px;
    margin: 0 auto;
    max-width: 570px;

    .header-wrapper {
      padding-top: 14px;
      padding-bottom: 14px;

      .subject-name {
        font-size: 20px;
        font-weight: 900;
        color: #212529;
      }
    }

    .content-wrapper {
      padding-top: 14px;
      padding-bottom: 14px;

      .video-title {
        font-size: 16px;
        font-weight: 700;
        color: #212529;
        padding-bottom: 10px;
      }

      .video-description {
        color: rgba(0,0,0,.54);
        font-size: 14px;
      }

      .owner-name {
        padding-top: 6px;
        padding-bottom: 6px;
        color: rgba(0,0,0,.54);
        font-size: 14px;
      }

    }
  }
</style>
